/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.core.base.analytics.di

import studio.oddpods.cauce.core.base.analytics.AnalyticsHelper
import studio.oddpods.cauce.core.base.analytics.PhiSafeAnalyticsHelper
import org.koin.core.module.Module
import org.koin.core.scope.Scope

/**
 * Registers the [AnalyticsHelper] binding for a platform, wrapping the provided
 * backend in [PhiSafeAnalyticsHelper] so free-text parameters are redacted
 * before they reach the analytics provider.
 *
 * Platform modules must use this helper instead of binding an [AnalyticsHelper]
 * directly. Binding a raw backend would bypass PHI redaction and is a
 * compliance hazard given Cauce's clinical-data roadmap.
 */
internal fun Module.bindPhiSafeAnalytics(
    backend: Scope.() -> AnalyticsHelper,
) {
    single<AnalyticsHelper> { PhiSafeAnalyticsHelper(backend()) }
}
